// Contact.jsx
import React from "react";

function Contact() {
    return (
        <section id="contact" className="bg-pink-600 text-white py-20">
            <div className="container mx-auto text-center">
                <h2 className="text-3xl font-bold mb-8">Entre em Contato</h2>
                <p className="max-w-2xl mx-auto mb-12 text-lg">
                    Vamos conversar sobre como posso apoiar sua empresa ou sua carreira.
                    Entre em contato pelos canais abaixo ou envie uma mensagem direta.
                </p>

                {/* Bloco de informações de contato */}
                <div className="flex flex-col md:flex-row justify-center gap-8 mb-12">
                    <div>
                        <p className="font-semibold">📧 E-mail</p>
                        <a
                            href="mailto:karlla.barbosa@email.com"
                            className="hover:underline"
                        >
                            karlla.barbosa@email.com
                        </a>
                    </div>
                    <div>
                        <p className="font-semibold">💼 LinkedIn</p>
                        <a
                            href="https://www.linkedin.com/in/karllabarbosa"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline"
                        >
                            linkedin.com/in/karllabarbosa
                        </a>
                    </div>
                    <div>
                        <p className="font-semibold">📱 WhatsApp</p>
                        <a
                            href="https://wa.me/5599999999999?text=Olá%20Karlla,%20gostaria%20de%20mais%20informações!"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:underline"
                        >
                            +55 (99) 99999-9999
                        </a>
                    </div>
                </div>

                {/* Formulário de contato */}
                <form className="max-w-lg mx-auto">
                    <input
                        type="text"
                        placeholder="Digite seu nome"
                        className="w-full p-3 mb-4 text-gray-900 rounded-lg"
                    />
                    <input
                        type="email"
                        placeholder="Digite seu email"
                        className="w-full p-3 mb-4 text-gray-900 rounded-lg"
                    />
                    <textarea
                        placeholder="Sua mensagem"
                        className="w-full p-3 mb-4 text-gray-900 rounded-lg"
                        rows="5"
                    />
                    <button
                        type="submit"
                        className="bg-white text-pink-600 px-6 py-3 rounded-full hover:bg-pink-200 transition duration-300"
                    >
                        Enviar Mensagem
                    </button>
                </form>
            </div>
        </section>
    );
}

export default Contact;
